/**
 * @fileoverview gRPC-Web generated client stub for dashboard.private.dashboard
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from "grpc-web";

import {
  GetDashboardRequest,
  GetDashboardResponse} from "./dashboard_pb";

export class DashboardServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: string; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options["format"] = "text";

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetDashboard = new grpcWeb.AbstractClientBase.MethodInfo(
    GetDashboardResponse,
    (request: GetDashboardRequest) => {
      return request.serializeBinary();
    },
    GetDashboardResponse.deserializeBinary
  );

  getDashboard(
    request: GetDashboardRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetDashboardResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/dashboard.private.dashboard.DashboardService/GetDashboard",
      request,
      metadata || {},
      this.methodInfoGetDashboard,
      callback);
  }

}

